import React from 'react';

const TIER_META = {
  FREE:          { label: 'FREE',    bg: '#F3F5F8', fg: '#5B6472', border: '#E3E8EF', icon: '○' },
  PREMIUM_EVENT: { label: 'PREMIUM', bg: '#146BFF', fg: '#FFFFFF', border: '#146BFF', icon: '★' },
  PREMIUM_LITE:  { label: 'LITE',    bg: '#EAF2FF', fg: '#146BFF', border: '#146BFF', icon: '◐' },
  PREMIUM:       { label: 'PREMIUM', bg: '#146BFF', fg: '#FFFFFF', border: '#146BFF', icon: '●' },
  PREMIUM_PLUS:  { label: 'PREMIUM+',bg: '#0B1B46', fg: '#FFFFFF', border: '#0B1B46', icon: '★' },
  LEGACY:        { label: 'LEGACY',  bg: '#F3F5F8', fg: '#0B1B46', border: '#0B1B46', icon: '◇' },
  PRO:           { label: 'PRO',     bg: '#0B1B46', fg: '#FFFFFF', border: '#0B1B46', icon: '★' },
};

export default function TierBadge({ tier, size = 'md', testId }) {
  const meta = TIER_META[tier] || TIER_META.FREE;
  const sm = size === 'sm';
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border font-extrabold tracking-wide ${sm ? 'px-2 py-0.5 text-[10px]' : 'px-2.5 py-1 text-[11px]'}`}
      style={{ backgroundColor: meta.bg, color: meta.fg, borderColor: meta.border }}
      data-testid={testId || `tier-badge-${(tier || 'free').toLowerCase()}`}
    >
      <span>{meta.icon}</span>
      <span>{meta.label}</span>
    </span>
  );
}
